<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/SocialMediaInfo">ขอเปลี่ยนแปลงข้อมูล Social Media</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ขอเปลี่ยนแปลงข้อมูล Social Media
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          ps-3
          pe-3
        " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                    ขอเปลี่ยนแปลงข้อมูล Social Media
                </div>
            </div>

            <div class="col">

                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ขอเปลี่ยนแปลงข้อมูล Social Media
                </div>
                <!--LINE ID-->
                <div class="border-bottom pb-3 position-relative">
                    <div class="mt-4 mt-lg-2">
                        <div class="d-flex align-items-center">
                            <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                                LINE ID
                                <img v-if="DataBinding.IsEditLineID" src="@/assets/images/checked.svg"
                                    class="svg-checked" />
                            </div>
                            <div class="icon-circle bg-blue-2" @click="ChechCreateJob('/SocialMediaInfo/EditLineID')">
                                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
                            </div>
                        </div>
                        <div v-if="DataBinding.IsEditLineID">
                            <div class="gray-3 fs-5 mt-1 font-family">
                                {{ DataBinding.NewLineID }}
                            </div>
                        </div>
                    </div>
                </div>
                <!--Facebook-->
                <div class="border-bottom pb-3 position-relative">
                    <div class="mt-4 mt-lg-2">
                        <div class="d-flex align-items-center">
                            <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                                Facebook
                                <img v-if="DataBinding.IsEditFacebook" src="@/assets/images/checked.svg"
                                    class="svg-checked" />
                            </div>
                            <div class="icon-circle bg-blue-2" @click="ChechCreateJob('/SocialMediaInfo/EditFacebook')">
                                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
                            </div>
                        </div>
                        <div v-if="DataBinding.IsEditFacebook">
                            <div class="gray-3 fs-5 mt-1 font-family">
                                {{ DataBinding.NewFacebookName }}
                            </div>
                        </div>
                    </div>
                </div>
                <!--TikTok-->
                <div class="border-bottom pb-3 position-relative">
                    <div class="mt-4 mt-lg-2">
                        <div class="d-flex align-items-center">
                            <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                                TikTok
                                <img v-if="DataBinding.IsEditTikTok" src="@/assets/images/checked.svg"
                                    class="svg-checked" />
                            </div>
                            <div class="icon-circle bg-blue-2" @click="ChechCreateJob('/SocialMediaInfo/EditTiktok')">
                                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
                            </div>
                        </div>
                        <div v-if="DataBinding.IsEditTikTok">
                            <div class="gray-3 fs-5 mt-1 font-family">
                                {{ DataBinding.NewTikTokName }}
                            </div>
                        </div>
                    </div>
                </div>
                <!--Instagram-->
                <div class="border-bottom pb-3 position-relative">
                    <div class="mt-4 mt-lg-2">
                        <div class="d-flex align-items-center">
                            <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                                Instagram
                                <img v-if="DataBinding.IsEditInstagram" src="@/assets/images/checked.svg"
                                    class="svg-checked" />
                            </div>
                            <div class="icon-circle bg-blue-2"
                                @click="ChechCreateJob('/SocialMediaInfo/EditInstagram')">
                                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
                            </div>
                        </div>
                        <div v-if="DataBinding.IsEditInstagram">
                            <div class="gray-3 fs-5 mt-1 font-family">
                                {{ DataBinding.NewInstagramName }}
                            </div>
                        </div>
                    </div>
                </div>
                <!--X-->
                <div class="border-bottom pb-3 position-relative">
                    <div class="mt-4 mt-lg-2">
                        <div class="d-flex align-items-center">
                            <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                                X
                                <img v-if="DataBinding.IsEditX" src="@/assets/images/checked.svg" class="svg-checked" />
                            </div>
                            <div class="icon-circle bg-blue-2" @click="ChechCreateJob('/SocialMediaInfo/EditX')">
                                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
                            </div>
                        </div>
                        <div v-if="DataBinding.IsEditX">
                            <div class="gray-3 fs-5 mt-1 font-family">
                                {{ DataBinding.NewXName }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class=" blue-1 pb-3 mt-2 fw-normal fs-4 position-relative font-family">
                    <label>
                        กรุณาตรวจสอบข้อมูลที่ขอแก้ไขก่อนกดปุ่ม ส่งข้อมูล
                    </label>
                </div>

                <div class="row mb-3 mt-2">
                    <div class="col-6 col-lg-6">
                        <button type="button" class="btn btn-light btn-cancel font-family-bla d-inline-block"
                            data-bs-toggle="modal" data-bs-target="#ResetStateModal">
                            ยกเลิก
                        </button>
                    </div>
                    <div class="col-6 col-lg-6 text-right">
                        <button type="button" class="btn btn-continue font-family d-inline-block" @click="Submit()">
                            ส่งข้อมูล
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- Modal Cancel -->
    <div class="modal fade font-family" id="ResetStateModal" tabindex="-1" aria-labelledby="ResetStateModalLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title fs-4" id="ResetStateModalLabel"></h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="icon-model">
                        <img src="@/assets/images/icon-warning.svg" class="w-100" />
                    </div>
                    <div class="massege fw-normal text-center">
                        <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
                        <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
                        <p class="mb-0 pt-lg-4">
                            ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
                        </p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light fw-normal popup_cancel" data-bs-dismiss="modal">
                        ไม่ต้องการ
                    </button>
                    <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal" @click="ResetState()">
                        ต้องการ
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal Cancel -->

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
    name: "SocialMediaInfo",
    components: {
        Menu,
        LoadingBs5,
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();

        //#region "[SocialMedia GetData()]" 
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
        http.get("AgencyERequest/GetSociaMediaData", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
            if (response.status == 200) {
                this.$store.state.SocialMediaInfo.LineID.Data.OldLineID = response.data.OldLineID;
                this.$store.state.SocialMediaInfo.Facebook.Data.OldFacebookName = response.data.OldFacebookName;
                this.$store.state.SocialMediaInfo.TikTok.Data.OldTikTokName = response.data.OldTikTokName;
                this.$store.state.SocialMediaInfo.Instagram.Data.OldInstagramName = response.data.OldInstagramName;
                this.$store.state.SocialMediaInfo.X.Data.OldXName = response.data.OldXName;
            }
            else {
                localStorage.removeItem("Token");
                localStorage.removeItem("AuthorizeToken");
                window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
            }
        }).catch((error) => {
            Swal.fire({
                icon: 'error',
                html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
            }).then(() => {
                localStorage.removeItem("Token");
                localStorage.removeItem("AuthorizeToken");
                window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
            });
        });
        //#endregion "[SocialMedia GetData()]" 

        this.BindingData();
    },
    data() {
        return {
            faCircleXmark: faCircleXmark,
            Loading: true,
            DataBinding: {
                IsEditLineID: false,
                OldLineID: '',
                NewLineID: '',

                IsEditFacebook: false,
                OldFacebookName: '',
                NewFacebookName: '',

                IsEditTikTok: false,
                OldTikTokName: '',
                NewTikTokName: '',

                IsEditInstagram: false,
                OldInstagramName: '',
                NewInstagramName: '',

                IsEditX: false,
                OldXName: '',
                NewXName: '',

            }
        };
    },
    methods: {
        Submit() {
            if (!this.DataBinding.IsEditLineID
                && !this.DataBinding.IsEditFacebook
                && !this.DataBinding.IsEditTikTok
                && !this.DataBinding.IsEditInstagram
                && !this.DataBinding.IsEditX) {
                Swal.fire({
                    icon: 'error',
                    html: '<lable class="fs-4 fw-normal font-family">กรุณาระบุข้อมูล Social Media ที่ต้องการแก้ไข</lable>',
                });
            } else {
                Swal.fire({
                    title: '<label class="font-eng fw-normal fs-4">ยืนยันการแก้ไขข้อมูล ?</label>',
                    html: '',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#0058A9',
                    confirmButtonText: '<label class="fw-normal font-eng fs-4" style="cursor: pointer;">Yes</label>',
                    cancelButtonColor: '#DEDEDE',
                    cancelButtonText: '<label class="fw-normal font-eng fs-4" style="cursor: pointer; color: black;">No</label>',
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {

                        this.Loading = true;
                        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
                        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
                        http.post("AgencyERequest/AddAER_ED_SOCIAL_MEDIA", this.DataBinding, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
                            if (res.status == 200 || res.status == 204) {
                                this.Loading = false;
                                Swal.fire({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ',
                                    showConfirmButton: false,
                                    timer: 1500
                                }).then(() => {
                                    this.ResetState();
                                    this.$router.push('/FinishSocialMediaInfoView');
                                });
                            }
                            else {
                                this.Loading = false;
                                Swal.fire({
                                    icon: 'error',
                                    html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
                                });
                            }
                        }).catch(() => {
                            this.Loading = false;
                            Swal.fire({
                                icon: 'error',
                                html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
                            });
                        });

                    }
                });
            }
        },
        ResetState() {
            this.$store.state.SocialMediaInfo.LineID.IsEditLineID = false;
            this.$store.state.SocialMediaInfo.LineID.Data.NewLineID = '';

            this.$store.state.SocialMediaInfo.Facebook.IsEditFacebook = false;
            this.$store.state.SocialMediaInfo.Facebook.Data.NewFacebookName = '';

            this.$store.state.SocialMediaInfo.TikTok.IsEditTikTok = false;
            this.$store.state.SocialMediaInfo.TikTok.Data.NewTikTokName = '';

            this.$store.state.SocialMediaInfo.Instagram.IsEditInstagram = false;
            this.$store.state.SocialMediaInfo.Instagram.Data.NewInstagramName = '';

            this.$store.state.SocialMediaInfo.X.IsEditX = false;
            this.$store.state.SocialMediaInfo.X.Data.NewXName = '';

            this.BindingData();
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
        BindingData() {
            this.DataBinding.IsEditLineID = this.$store.state.SocialMediaInfo.LineID.IsEditLineID;
            this.DataBinding.OldLineID = this.$store.state.SocialMediaInfo.LineID.Data.OldLineID;
            this.DataBinding.NewLineID = this.$store.state.SocialMediaInfo.LineID.Data.NewLineID;

            this.DataBinding.IsEditFacebook = this.$store.state.SocialMediaInfo.Facebook.IsEditFacebook;
            this.DataBinding.OldFacebookName = this.$store.state.SocialMediaInfo.Facebook.Data.OldFacebookName;
            this.DataBinding.NewFacebookName = this.$store.state.SocialMediaInfo.Facebook.Data.NewFacebookName;

            this.DataBinding.IsEditTikTok = this.$store.state.SocialMediaInfo.TikTok.IsEditTikTok;
            this.DataBinding.OldTikTokName = this.$store.state.SocialMediaInfo.TikTok.Data.OldTikTokName;
            this.DataBinding.NewTikTokName = this.$store.state.SocialMediaInfo.TikTok.Data.NewTikTokName;

            this.DataBinding.IsEditInstagram = this.$store.state.SocialMediaInfo.Instagram.IsEditInstagram;
            this.DataBinding.OldInstagramName = this.$store.state.SocialMediaInfo.Instagram.Data.OldInstagramName;
            this.DataBinding.NewInstagramName = this.$store.state.SocialMediaInfo.Instagram.Data.NewInstagramName;

            this.DataBinding.IsEditX = this.$store.state.SocialMediaInfo.X.IsEditX;
            this.DataBinding.OldXName = this.$store.state.SocialMediaInfo.X.Data.OldXName;
            this.DataBinding.NewXName = this.$store.state.SocialMediaInfo.X.Data.NewXName;

        },
        ChechCreateJob(to) {
            this.Authorization();
            this.$router.push(to);
        },
    },
};

</script>

<style scoped>
.font-family-bla {
    font-family: "DB Heavent";
}
</style>